import { NotFoundView, StoreLoading } from "views/guards";
import { useCallback, useState } from "react";

import { EndSaleModal } from "components/modals/EndSale";
import { ErrorModal } from "../AdminItems/ErrorModal";
import { IArt } from "state/artworks";
import { InfiniteProgress } from "components/modals/InfiniteProgress";
import { ItemViewContent } from "./ItemViewContent";
import { Layout } from "components/Layout";
import { PurchaseDialog } from "components/PurchaseDialog";
import { PurchaseSuccess } from "./PurchaseSuccess";
import { isSale } from "state/sales";
import { useDisclosure } from "@chakra-ui/react";
import { useLocalState } from "./ItemView.state";
import { useParams } from "react-router-dom";

export const ItemView: React.FC = () => {
  const {
    isOpen: isPurchaseOpen,
    onClose: closePurchase,
    onOpen: openPurchase,
  } = useDisclosure();
  const {
    isOpen: isEndSaleOpen,
    onClose: closeEndSale,
    onOpen: openEndSale,
  } = useDisclosure();
  const [purchaseSuccess, setPurchaseSuccess] = useState(false);
  const [purchaseArtwork, setPurchaseArtwork] = useState<IArt>();

  const { artworkId, saleId } = useParams();
  const { item, pending, progress, resetProgress, handleEndSale } =
    useLocalState({
      saleId,
      artworkId,
    });

  const _isSale = item && isSale(item);

  const handleBuyNft = useCallback(() => {
    openPurchase();
  }, [openPurchase]);

  const handlePurchaseSuccess = (mint?: IArt | null) => {
    if (mint) {
      setPurchaseArtwork(mint);
    }
    closePurchase();
    setPurchaseSuccess(true);
  };

  return item ? (
    <Layout>
      {!purchaseSuccess && (
        <ItemViewContent
          item={item}
          onBuyNft={handleBuyNft}
          onClaim={handleEndSale}
          onEndSale={openEndSale}
        />
      )}

      {purchaseSuccess && _isSale && (
        <PurchaseSuccess artwork={purchaseArtwork ?? item.artwork} />
      )}

      {_isSale && (
        <PurchaseDialog
          isOpen={isPurchaseOpen}
          onClose={closePurchase}
          sale={item}
          onPurchaseSuccess={handlePurchaseSuccess}
        />
      )}

      <InfiniteProgress
        isOpen={progress.visible}
        title={progress.title}
        subtitle={progress.subtitle}
        onClose={resetProgress}
      />
      {progress.error && (
        <ErrorModal error={progress.error} onClose={resetProgress} />
      )}

      {_isSale && (
        <EndSaleModal
          isOpen={isEndSaleOpen}
          onClose={closeEndSale}
          sale={item}
        />
      )}
    </Layout>
  ) : pending ? (
    <StoreLoading title="Loading" />
  ) : (
    <NotFoundView />
  );
};
